export const IconState = ({ icon: Icon, title, description, dashedBorder = true }) => {
  return (
    <div className={`mb-12 mt-4 rounded-lg p-8 text-center ${dashedBorder ? 'border border-dashed' : ''} h-full flex items-center justify-center bg-surface dark:bg-gray-870 text-gray-500 dark:text-gray-300 border-gray-300 dark:border-gray-700`}>
      <div className="flex flex-col items-center justify-center space-y-3">
        <Icon className="h-10 w-10 text-gray-300 dark:text-gray-400" aria-hidden="true" />
        <p className="text-md text-gray-700 dark:text-gray-100">{title}</p>
        <p className="text-sm text-gray-400 dark:text-gray-300">{description}</p>
      </div>
    </div>
  );
}